// Keyboard helpers for form dialogs: focus the first field on open and walk
// fields with Enter (accounting-software style), confirming after the last one.

export const getFocusableFields = (container) => {
    if (!container?.querySelectorAll) return [];
    return Array.from(
        container.querySelectorAll(
            'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [contenteditable="true"]'
        )
    ).filter(
        (el) =>
            el.offsetParent !== null &&
            // MUI Select renders a hidden aria-hidden native input; skip it.
            el.getAttribute('aria-hidden') !== 'true' &&
            !el.closest('[aria-hidden="true"]')
    );
};

export const focusFirstField = (container) => {
    const fields = getFocusableFields(container);
    if (fields[0]) {
        fields[0].focus();
        fields[0].select?.();
    }
};

// Move focus to the field after `current`. Returns true when it moved,
// false when `current` is the last field (caller can then confirm).
export const focusNextField = (container, current) => {
    const fields = getFocusableFields(container);
    const currentIndex = fields.indexOf(current);
    if (currentIndex !== -1 && currentIndex < fields.length - 1) {
        const next = fields[currentIndex + 1];
        next.focus();
        next.select?.();
        return true;
    }
    return false;
};

// Shared Enter handling for form dialogs:
// - Enter on a button: let the button's own click happen.
// - Ctrl/Cmd+Enter: confirm immediately (when allowed).
// - Enter on a field: move to the next field; after the last field, confirm.
export const handleDialogEnterNavigation = (event, { canConfirm, onConfirm }) => {
    if (event.key !== 'Enter' || event.shiftKey || event.defaultMuiPrevented) return;
    if (event.target?.tagName === 'BUTTON') return;

    if (event.ctrlKey || event.metaKey) {
        if (canConfirm) {
            event.preventDefault();
            onConfirm();
        }
        return;
    }

    const moved = focusNextField(event.currentTarget, event.target);
    if (moved) {
        event.preventDefault();
        return;
    }
    if (canConfirm) {
        event.preventDefault();
        onConfirm();
    }
};
